module.exports = __webpack_public_path__ + "img/coupon_bg12.ee06905c.png";